// Copyright (c) 2016 Deere & Company

import Report, {getDefaultState} from '../../update-machine-status-history/state/report';
import actions from '../../actions-list';

const updateUpdateMachineStatusHistoryReport = (state, action) =>
    Report.update(state, {
        $set: action.data
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.CREATE_UPDATE_MACHINE_STATUS_HISTORY_REPORT_SUCCESS]: updateUpdateMachineStatusHistoryReport,
        [actions.RESET_REPORT_SEARCH_RESULTS]: updateUpdateMachineStatusHistoryReport
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/update-machine-status-history/reducers/report.js